import { useEffect, useState } from "react";
import axios from "axios";
import IsLoading from "../../../isLoading";
import "./admissionhub.css";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import * as Action from "../../../store/redux/admission_reducer.js";
import Admitted from "./admission_hub_Comps/Admitted";
import Pendings from "./admission_hub_Comps/Pendings";
import Uncompleted from "./admission_hub_Comps/UncompletedForm";
import Rejecteds from "./admission_hub_Comps/Rejecteds";
import "./admissionhubDetails.css";

export default function AdmissionHubDetails() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { id, appNo } = useParams();
  const studentData = useSelector(
    (state) => state.admissionActions.queue.Applicant,
  );
  console.log(studentData);
  const authcheck = useSelector((state) => state.admissionActions);

  function logOut() {
    dispatch(DispatchADMhubLogOut());
  }

  const DispatchADMhubLogOut = () => async (dispatch) => {
    try {
      dispatch(Action.logOut());
    } catch (error) {
      console.log(error);
    }
  };
  console.log(authcheck);
  function statusResponse() {
    if (studentData?.admissions.status === "admitted") {
      return <Admitted logOut={logOut} />;
    } else if (
      (studentData?.account_status.registration_status === "completed" &&
        studentData?.admissions.status === "pending") ||
      studentData?.admissions.status === "recommended"
    ) {
      return <Pendings logOut={logOut} />;
    } else if (
      studentData?.account_status.registration_status === "pending" &&
      studentData?.admissions.status === "pending"
    ) {
      return <Uncompleted logOut={logOut} />;
    } else if (studentData?.admissions.status === "rejected") {
      return <Rejecteds logOut={logOut} />;
    }
  }

  return (
    <section className="sectionAdmissionHub fx-cl fx-ac fx-jc">
      {loading ? <IsLoading /> : null}
      <div className="fx-cl fx-jc checkADM space2 fs4">
        <div className="admissionState">{statusResponse()}</div>
      </div>
    </section>
  );
}
